import React from 'react';
import { Link } from 'react-router';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';

const InstitutionDashboard = observer(class InstitutionDashboard extends React.Component {
  constructor() {
    super()
    this.showProctorGroupWarning = this.showProctorGroupWarning.bind(this);
    this.getDashboardInfo = this.getDashboardInfo.bind(this);
    this.renderResults = this.renderResults.bind(this);
  }

  componentWillMount() {
    this.props.store.AdminStore.getOverviewStats()
    this.state = {
      drawerContent: null,
      drawerOpen: false,
    }

    this.getDashboardInfo();

    // Get proctor groups so we can show a warning if none exist
    this.props.store.ProctorStore.getProctorGroups(this, this.showProctorGroupWarning);
  }

  showProctorGroupWarning() {
    const { translation } = this.props;
    this.props.store.SessionStore.noticeContent.body = translation.no_proctor_groups.body;
    this.props.store.SessionStore.noticeContent.linkText = translation.no_proctor_groups.link;
    this.props.store.SessionStore.noticeContent.linkUrl = '/settings/proctor-groups';
    this.props.store.SessionStore.notice = true;
  }

  getDashboardInfo() {
    this.props.store.AdminStore.approvalsFilter = {
      status: 'requested'
    };

    this.props.store.AdminStore.getExamConfigurations();
    this.props.store.AdminStore.getInstallApprovals();
    this.props.store.AdminStore.getOverviewStats();
    this.props.store.ProctorStore.getProctorTypes();
  }

  renderResults() {
    const { translation } = this.props;
    const { AdminStore, SessionStore } = this.props.store;

    if(!SessionStore.loading) {
      return (
        <div className="wrap">
          <ul className="card-list">
            <li className="card">
              <icons.icon_text />

              <div className="card__content">
                <h3 className="card__heading">
                  {AdminStore.configurationCount} {translation.exam_approvals}
                </h3>

                {AdminStore.configurationCount > 0 &&
                  <Link className="card__btn" to="exam-approvals">
                    <icons.iconCheck />
                    {translation.review_button}
                  </Link>
                }
              </div>
            </li>
            <li className="card card--positive">
              <icons.iconUsers />

              <div className="card__content">
                <h3 className="card__heading">
                  {AdminStore.approvals.length} {translation.proctor_approvals}
                </h3>

                {AdminStore.approvals.length > 0 &&
                  <button
                    className="card__btn"
                    onClick={(e) => {toggleDrawer(e, this, 'ApproveProctor')}}
                  >
                    <icons.iconCheck />
                    {translation.review_button}
                  </button>
                }
              </div>
            </li>
          </ul>

          <div className="chart">
            <h3 className="chart__title">{translation.upcoming_sessions}</h3>

            <ResponsiveContainer height={300}>
              <BarChart
                data={this.props.store.AdminStore.stats.slice()}
                animation={false}
              >
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />

                <Bar
                  barSize={30}
                  dataKey="messaging"
                  stackId="a"
                  fill="#bba7e4"
                  isAnimationActive={false}
                />

                <Bar
                  barSize={30}
                  dataKey="ad-hoc"
                  stackId="a"
                  fill="#f44c87"
                  isAnimationActive={false}
                />

                <Bar
                  barSize={30}
                  dataKey="instructor-as-proctor"
                  stackId="a" fill="#47b8c6"
                  isAnimationActive={false}
                />

                <Bar
                  barSize={30}
                  dataKey="register-blast"
                  stackId="a"
                  fill="#2cc477"
                  isAnimationActive={false}
                />
                
                <Bar
                  barSize={30}
                  dataKey="examity"
                  stackId="a"
                  fill="#f69432"
                  isAnimationActive={false}
                />

                <Bar
                  barSize={30}
                  dataKey="proctoru"
                  stackId="a"
                  fill="#1073af"
                  isAnimationActive={false}
                />

              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>
          </div>
        </header>

        {this.renderResults()}

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          callback={this.getDashboardInfo}
          parent={this}
          {...this.props}
        />
      </main>
    );
  }
})

export default translate('InstitutionDashboard')(InstitutionDashboard);



// WEBPACK FOOTER //
// ./src/app/components/InstitutionDashboard/InstitutionDashboard.js